/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Grid from "@civicplus/preamble-ui/lib/Grid";
import Typography from "@civicplus/preamble-ui/lib/Typography";
import { concatStringValues } from "../../shared/functions";
import { getUsersName } from "@civicplus/preamble-ui/lib/Utilities/StringHelper";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import { MessageHistory } from "../../../../entities/Message";
import { renderListSection } from "./shared";

const useStyles = makeStyles((theme) => ({
    detailsContainer: {
        "& > div": {
            padding: "0px 0px 5px 12px"
        },
        [theme.breakpoints.down("md")]: {
            padding: "5px 15px"
        }
    },
    contentBorder: {
        border: "1px solid " + theme.palette.divider,
        padding: "1rem"
    },
    fieldName: {
        [theme.breakpoints.down("md")]: {
            fontWeight: theme.typography.fontWeightBold,
            marginBottom: 0
        }
    },
    fieldValue: {
        [theme.breakpoints.down("md")]: {
            marginBottom: 15
        }
    },
    innerEmailContent: {
        whiteSpace: "no-wrap",
        wordBreak: "break-word",
        textWrap: "wrap"
    },
    innerWrapper: {
        marginBottom: 25
    },
    plainTextBody: {
        wordBreak: "break-word",
        textWrap: "wrap",
        padding: 20
    }
}));

interface MessageHistoryEmailDetailsTabProps {
    messageHistory: MessageHistory;
    orgId: string | undefined | null;
}

const MessageHistoryEmailDetailsTab: React.FC<MessageHistoryEmailDetailsTabProps> = ({ messageHistory, orgId }) => {
    const classes = useStyles();
    let inner = <></>;

    if (messageHistory.emailContent !== null && messageHistory.emailContent !== undefined) {
        inner = (
            <div
                id="email-content"
                dangerouslySetInnerHTML={{ __html: messageHistory.emailContent }}
                className={classes.innerEmailContent}
            />
        );
    }

    return (
        <Grid container={true} spacing={2} className={classes.detailsContainer}>
            <Grid xs={12} sm={3} md={2}>
                <Typography paragraph={true} className={classes.fieldName}>
                    Sender Name:
                </Typography>
            </Grid>

            <Grid xs={12} sm={9} md={10}>
                <Typography color="textSecondary" className={classes.fieldValue}>
                    {getUsersName(messageHistory.sender!)}
                </Typography>
            </Grid>

            <Grid xs={12} sm={3} md={2}>
                <Typography paragraph={true} className={classes.fieldName}>
                    Subject:
                </Typography>
            </Grid>

            <Grid xs={12} sm={9} md={10}>
                <Typography color="textSecondary" className={classes.fieldValue} data-testid="subjectValue">
                    {messageHistory.subject}
                </Typography>
            </Grid>

            <Grid xs={12} sm={3} md={2}>
                <Typography paragraph={true} className={classes.fieldName}>
                    From:
                </Typography>
            </Grid>

            <Grid xs={12} sm={9} md={10}>
                <Typography color="textSecondary" className={classes.fieldValue}>
                    {`${messageHistory.fromName ?? ""} <noreply@civicplus.com>`}
                </Typography>
            </Grid>

            {messageHistory.sendAsSingleEmail && (
                <>
                    {messageHistory.recipients && messageHistory.recipients.length > 0 && (
                        <>
                            <Grid xs={12} sm={3} md={2}>
                                <Typography paragraph={true} className={classes.fieldName}>
                                    To:
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={9} md={10}>
                                <Typography
                                    color="textSecondary"
                                    className={classes.fieldValue}
                                    data-testid="recipientsValue"
                                >
                                    {concatStringValues(messageHistory.recipients || [])}
                                </Typography>
                            </Grid>
                        </>
                    )}

                    {messageHistory.carbonCopy && messageHistory.carbonCopy.length > 0 && (
                        <>
                            <Grid xs={12} sm={3} md={2}>
                                <Typography paragraph={true} className={classes.fieldName}>
                                    CC:
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={9} md={10}>
                                <Typography
                                    color="textSecondary"
                                    className={classes.fieldValue}
                                    data-testid="carbonCopyValue"
                                >
                                    {concatStringValues(messageHistory.carbonCopy)}
                                </Typography>
                            </Grid>
                        </>
                    )}

                    {messageHistory.blindCarbonCopy && messageHistory.blindCarbonCopy.length > 0 && (
                        <>
                            <Grid xs={12} sm={3} md={2}>
                                <Typography paragraph={true} className={classes.fieldName}>
                                    BCC:
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={9} md={10}>
                                <Typography
                                    color="textSecondary"
                                    className={classes.fieldValue}
                                    data-testid="blindCarbonCopyValue"
                                >
                                    {concatStringValues(messageHistory.blindCarbonCopy)}
                                </Typography>
                            </Grid>
                        </>
                    )}
                </>
            )}

            <Grid xs={12} sm={3} md={2}>
                <Typography paragraph={true} className={classes.fieldName}>
                    Lists:
                </Typography>
            </Grid>

            <Grid xs={12} sm={9} md={10}>
                <Typography color="textSecondary" className={classes.fieldValue}>
                    {renderListSection(orgId, messageHistory.lists)}
                </Typography>
            </Grid>

            <Grid xs={12} className={classes.innerWrapper}>
                <div className={classes.contentBorder}>{inner}</div>
            </Grid>

            {messageHistory.plainTextBody && (
                <>
                    <Grid xs={12}>
                        <Typography paragraph={true} className={classes.fieldName} style={{ fontWeight: "bold" }}>
                            Plain Text Content:
                        </Typography>
                    </Grid>

                    <Grid xs={12} className={classes.contentBorder} style={{ marginLeft: 12 }}>
                        <Typography className={classes.plainTextBody}>{messageHistory.plainTextBody}</Typography>
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default MessageHistoryEmailDetailsTab;
